import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as ExtratoActions } from "../ducks/extrato";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as LoadingActions } from "../ducks/loading";
import { formatReal } from "../../helpers";
import moment from "moment";

export function* getListExtrato() {
  try {
    yield put(LoadingActions.setLoading());
    const { filter } = yield select(state => state.extrato);
    const { mes, ano, group } = yield select(state => state.filtrosExtrato);
    if (!filter.search) {
      filter.date = `${ano.split("-", 1)[0]}-${mes.split("-", 1)[0]}-01`;
      if (group.split("-", 1)[0]) {
        filter.group = group.split("-", 1)[0];
      } else {
        filter.group = "";
      }
    }
    const { data } = yield call(api.post, `/extracts/finances`, filter);

    const dataPayload = data.map(d => ({
      ...d,
      totalRC: d.total_transactions_credit_paid,
      totalRP: d.total_transactions_credit_not_paid,
      totalPC: d.total_transactions_debit_paid,
      totalPP: d.total_transactions_debit_not_paid,
      totalComissao: d.total_receipts,
      totalEstornos: d.total_estornos,
      totalRepasses: d.total_comissions,
      id:
        group.split("-", 1)[0] === "stores"
          ? d.store_id
          : moment(d.date).format("DD/MM/YYYY"),
      total_comissions: `<span class="flex-end red-alert font-weight-normal">- ${formatReal(
        d.total_comissions
      )}</span>&nbsp;(${d.qntd_comissions})`,
      total_estornos: `<span class="flex-end red-alert font-weight-normal">- ${formatReal(
        d.total_estornos
      )}</span>&nbsp;(${d.qntd_estornos})`,
      total_receipts: `<span class="flex-end green-alert font-weight-normal">+ ${formatReal(
        d.total_receipts
      )}</span>&nbsp;(${d.qntd_receipts})`,
      total_transactions_credit_not_paid: `<span class="flex-end green-alert font-weight-normal">+ ${formatReal(
        d.total_transactions_credit_not_paid
      )}</span>&nbsp;(${d.qntd_transactions_credit_not_paid})`,
      total_transactions_credit_paid: `<span class="flex-end green-alert font-weight-normal">+ ${formatReal(
        d.total_transactions_credit_paid
      )}</span>&nbsp;(${d.qntd_transactions_credit_paid})`,
      total_transactions_debit_not_paid: `<span class="flex-end red-alert font-weight-normal">- ${formatReal(
        d.total_transactions_debit_not_paid
      )}</span>&nbsp;(${d.qntd_transactions_debit_not_paid})`,
      total_transactions_debit_paid: `<span class="flex-end red-alert font-weight-normal">- ${formatReal(
        d.total_transactions_debit_paid
      )}</span>&nbsp;(${d.qntd_transactions_debit_paid})`,
      date:
        group.split("-", 1)[0] === "stores"
          ? d.store
          : moment(d.date).format("DD/MM/YYYY"),
      sum_1: `<span class="flex-end ">${formatReal(
        d.total_transactions_credit_paid +
          d.total_transactions_credit_not_paid -
          d.total_transactions_debit_paid -
          d.total_transactions_debit_not_paid
      )}</span>`,
      sum_2: `<span class="flex-end ">${formatReal(
        d.total_receipts - d.total_estornos - d.total_comissions
      )}</span>`,
      sum_3: `<span class="flex-end font-weight-bold ${
        d.total_transactions_credit_paid +
          d.total_transactions_credit_not_paid -
          d.total_transactions_debit_paid -
          d.total_transactions_debit_not_paid +
          d.total_receipts -
          d.total_estornos -
          d.total_comissions <
        0
          ? "red-alert"
          : "blue-alert"
      }">${formatReal(
        d.total_transactions_credit_paid +
          d.total_transactions_credit_not_paid -
          d.total_transactions_debit_paid -
          d.total_transactions_debit_not_paid +
          d.total_receipts -
          d.total_estornos -
          d.total_comissions
      )}</span>`,
      total1:
        d.total_transactions_credit_paid +
        d.total_transactions_credit_not_paid -
        d.total_transactions_debit_paid -
        d.total_transactions_debit_not_paid,
      total2: d.total_receipts - d.total_estornos - d.total_comissions,
      total3:
        d.total_transactions_credit_paid +
        d.total_transactions_credit_not_paid -
        d.total_transactions_debit_paid -
        d.total_transactions_debit_not_paid +
        d.total_receipts -
        d.total_estornos -
        d.total_comissions
    }));

    yield put(ExtratoActions.getListExtratoSuccess(dataPayload));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/extrato.js